import { Instagram } from "lucide-react";
import { BRAND, NAV_LINKS } from "../../lib/data";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-zp-cream text-zp-navy border-t border-zp-line"
    >
      {/* Decorative stripe top */}
      <div className="h-2 cabana-stripes-blue opacity-90" />

      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-20 md:py-28">
        {/* Massive brand */}
        <div className="border-b border-zp-line pb-12 mb-12">
          <h2 className="font-serif text-[18vw] md:text-[14vw] lg:text-[12vw] leading-[0.85] tracking-tighter text-zp-navy">
            zénith<span className="italic font-light"> plage</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <img
              src={BRAND.logoUrl}
              alt="Zénith Plage"
              className="w-16 h-16 rounded-full"
            />
            <p className="mt-6 font-serif italic text-2xl text-zp-navy leading-snug max-w-md">
              {BRAND.tagline}
            </p>
            <p className="mt-4 text-zp-muted font-light max-w-md">
              Plage privée, restaurant et bar à Palavas-les-Flots. Ouvert toute
              la saison, en famille comme entre amis.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="overline text-xs text-zp-muted mb-5">Navigation</div>
            <ul className="space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    data-testid={`footer-link-${link.href.replace("#", "")}`}
                    className="link-underline font-serif text-xl text-zp-navy"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline text-xs text-zp-muted mb-5">Nous trouver</div>
            <address className="not-italic space-y-3 font-light text-zp-ink">
              <div>{BRAND.address.line1}</div>
              <div>{BRAND.address.line2}</div>
              <div className="pt-2">
                <a
                  href={BRAND.phoneHref}
                  data-testid="footer-phone"
                  className="font-serif text-xl text-zp-navy link-underline"
                >
                  {BRAND.phone}
                </a>
              </div>
              <div>
                <a
                  href={BRAND.emailHref}
                  data-testid="footer-email"
                  className="link-underline text-zp-navy"
                >
                  {BRAND.email}
                </a>
              </div>
              <div className="pt-3">
                <a
                  href={BRAND.instagramUrl}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-instagram"
                  className="inline-flex items-center gap-2 link-underline text-sm tracking-widest uppercase"
                >
                  <Instagram size={14} />
                  @zenithplage
                </a>
              </div>
            </address>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-zp-line flex flex-col md:flex-row md:items-center justify-between gap-4 text-xs text-zp-muted">
          <div>© {new Date().getFullYear()} Zénith Plage — Palavas-les-Flots. Tous droits réservés.</div>
          <div className="font-serif italic">
            Le soleil, à son zénith. Tous les jours, 8h — 1h.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
